<script>
import ThemeSwitcher from '../ThemeSwitcher';
import feather from 'feather-icons';
import AppHeaderLinks from './AppHeaderLinks.vue';

export default {
	components: {
		ThemeSwitcher,
		AppHeaderLinks,
	},
	data() {
		return {
			isOpen: false,
			theme: '',
			linkedInUrl: 'https://www.linkedin.com/in/joseph-w-valdez',
		};
	},

	created() {
		this.theme = localStorage.getItem('theme') || 'light';
	},
	mounted() {
		feather.replace();
		this.theme = localStorage.getItem('theme') || 'light';

    // Add event listener to close the menu when clicking away from it
    document.addEventListener('click', this.closeMenuOnClickAway);
  },
  beforeUnmount() {
    // Remove event listener when component is destroyed to prevent memory leaks
    document.removeEventListener('click', this.closeMenuOnClickAway);
  },
	methods: {
    updateTheme(theme) {
      this.theme = theme;
    },
    closeMenuOnClickAway(event) {
      if (this.isOpen && !this.$refs.hamburger.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  updated() {
    feather.replace();
  },
};
</script>

<template>
	<nav id="nav" class="sticky top-0 z-50 bg-secondary-light/95 dark:bg-primary-dark/95 backdrop-blur-sm sm:container sm:mx-auto border-b border-gray-200/50 dark:border-gray-800/50">
		<div class="z-10 max-w-screen-lg xl:max-w-screen-xl block sm:flex sm:justify-between sm:items-center py-4 sm:py-6" >
			<div class="flex justify-between items-center px-4 sm:px-0">
				<div>
					<router-link to="/"
						><img
							v-if="theme === 'light'"
							src="@/assets/images/logo-dark.png"
							class="w-36 hover:scale-105 duration-200"
							alt="Dark Logo"
						/>
						<img
							v-else
							src="@/assets/images/logo-light.png"
							class="w-36 hover:scale-105 duration-200"
							alt="Light Logo"
						/>
					</router-link>
				</div>
				<!-- Theme switcher small screen -->
				<theme-switcher
					:theme="theme"
					@themeChanged="updateTheme"
					class="block sm:hidden bg-ternary-light dark:bg-ternary-dark hover:bg-hover-light dark:hover:bg-hover-dark hover:shadow-sm px-2.5 py-2 rounded-lg"
				/>

				<!-- Small screen hamburger menu -->
				<div class="sm:hidden">
					<button
						@click="isOpen = !isOpen"
						type="button"
						class="focus:outline-none"
						aria-label="Hamburger Menu"
						ref='hamburger'
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							class="h-7 w-7 fill-current text-secondary-dark dark:text-ternary-light"
						>
							<path
								v-if="isOpen"
								fill-rule="evenodd"
								d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
								clip-rule="evenodd"
							></path>
							<path
								v-if="!isOpen"
								fill-rule="evenodd"
								d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
							></path>
						</svg>
					</button>
				</div>
			</div>

			<AppHeaderLinks :linkedInUrl="linkedInUrl" :isOpen="isOpen" />
			<div class="hidden sm:flex justify-between items-center flex-col md:flex-row" >
				<div class="hidden md:flex items-center gap-3">
					<a
						href="/files/Joseph Valdez - Resume.pdf"
						target="_blank"
						rel="noopener noreferrer"
						class="text-md font-general-medium bg-indigo-500 hover:bg-indigo-600 text-white shadow-sm rounded-md px-5 py-2.5 duration-500 inline-block"
						aria-label="View resume PDF"
					>
						View My Resume!
					</a>
					<a
						:href="linkedInUrl"
						target="_blank"
						rel="noopener noreferrer"
						class="text-md font-general-medium bg-indigo-500 hover:bg-primary-light text-white hover:text-[#6366F1] shadow-sm rounded-md px-5 py-2.5 duration-500 inline-block"
						aria-label="LinkedIn Profile"
					>
						Let's Connect!
					</a>
				</div>
				<theme-switcher
					:theme="theme"
					@themeChanged="updateTheme"
					class="ml-8 bg-primary-light dark:bg-ternary-dark hover:bg-[#6366F1] dark:hover:bg-[#6366F1] px-3 py-2 shadow-sm rounded-xl cursor-pointer duration-500 "
				/>
			</div>
		</div>
	</nav>
</template>

<style scoped>
#nav {
	backdrop-filter: blur(8px);
	-webkit-backdrop-filter: blur(8px);
}

#nav a.router-link-exact-active {
	@apply text-indigo-700;
	@apply dark:text-indigo-400;
	@apply font-medium;
}
</style>
